import React, { useEffect, useState } from "react";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Video from "@/components/landing/Video";
import Stats from "@/components/landing/Stats";
import About from "@/components/landing/About";
import HowItWorks from "@/components/landing/HowItWorks";
import Founder from "@/components/landing/Founder";
import Footer from "@/components/landing/Footer";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Landing() {
  const [registrationCount, setRegistrationCount] = useState(0);

  useEffect(() => {
    const fetchCount = async () => {
      try {
        const res = await axios.get(`${API}/registrations/count`);
        setRegistrationCount(res.data.count || 0);
      } catch (e) {
        // silent fail
      }
    };
    fetchCount();
  }, []);

  const handleNewRegistration = () => {
    setRegistrationCount((c) => c + 1);
  };

  return (
    <div data-testid="landing-page" className="relative">
      <Nav registrationCount={registrationCount} />
      <Hero
        registrationCount={registrationCount}
        onRegistered={handleNewRegistration}
      />
      <Video />
      <About />
      <Founder />
      <HowItWorks />
      <Stats />
      <Footer />
    </div>
  );
}
